import React from 'react';
import { createSvgIcon } from '../Svg';

export default createSvgIcon(
  <path d="M14 24C14 21.2333 11.7667 19 9 19C6.23333 19 4 21.2333 4 24C4 26.7667 6.23333 29 9 29C11.7667 29 14 26.7667 14 24ZM19 24C19 26.7667 21.2333 29 24 29C26.7667 29 29 26.7667 29 24C29 21.2333 26.7667 19 24 19C21.2333 19 19 21.2333 19 24ZM34 24C34 26.7667 36.2333 29 39 29C41.7667 29 44 26.7667 44 24C44 21.2333 41.7667 19 39 19C36.2333 19 34 21.2333 34 24Z" />,
  'bullets-horizontal'
);
